import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Menos presión en la cintura y abdomen', 'Menos antojos por la tarde/noche', 'Mejor digestión y menos gases', 'Más ligereza al caminar y moverte', 'Más energía y ganas de seguir cuidándote'];
  return <section className="py-24 bg-[#8BA888]/10" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-4">
            <h2 className="text-4xl font-bold text-[#2D3748] mb-6" data-id="element-5">
              Qué cambia cuando lo haces
            </h2>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-6">
              No te voy a prometer milagros imposibles. Te voy a prometer algo
              mejor:{' '}
              <strong className="text-[#E07856]" data-id="element-7">claridad y estructura.</strong>
            </p>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-8">
              Cuando tu día tiene una rutina simple, tu cuerpo deja de estar en
              "modo caos" y empieza a desinflamarse naturalmente.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white p-8 sm:p-10 rounded-3xl shadow-xl" data-id="element-9">
            <h3 className="text-2xl font-bold text-[#8BA888] mb-8" data-id="element-10">
              Lo que empezarás a notar:
            </h3>
            <ul className="space-y-6" data-id="element-11">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3 + index * 0.1
            }} className="flex items-start" data-id="element-12">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#8BA888]/20 flex items-center justify-center mt-1" data-id="element-13">
                    <Check className="w-5 h-5 text-[#8BA888]" data-id="element-14" />
                  </div>
                  <span className="ml-4 text-xl text-gray-700" data-id="element-15">{benefit}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}